import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import dayjs from "dayjs";
import Loader from "../../general/Loader";
import { formatCurrency } from "../../../utils/helpers";

const ReporteOrdenCarga = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const [despacho, setDespacho] = useState({});
    const [loading, setLoading] = useState(true);

    const getReporteData = async () => {
        setLoading(true);

        const url = `despachos/${id}`;
        const res = await request(url);
        setDespacho({
            ...res.data,
            facturas: res.data.facturas?.reverse(),
        });
        setLoading(false);
    };

    useEffect(() => {
        getReporteData();
    }, []);

    // Espera a que loading pase a false, con los datos ya reflejados en el
    // DOM, antes de abrir el diálogo de impresión.
    useEffect(() => {
        if (!loading) {
            window.print();
        }
    }, [loading]);

    return (<>
		<style>{`@page {size: A4 landscape}`}</style>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">
                Reporte orden de carga
            </h2>
            <div className="col-md-12 text-center">
                {sucursal.nombre} •{" "}
                {dayjs().format("DD/MM/YYYY")}
            </div>
        </div>

        {loading && <Loader/> }

        {!loading && <>
            <div className="row mt-3">
                <div className="col-12 text-right">
                    <strong>NO.</strong> {despacho.numero_despacho}
                </div>
                
                <div className="col-12 col-md-6">
                    <strong>{despacho.tipo_despacho === "Carga" ? "CHOFER" : "ENTREGADO POR"}:</strong>
                    {despacho.tipo_despacho === "Carga" && despacho.empleado ? `${despacho.empleado.nombre} ${despacho.empleado.apellido}` : " "}
                    {despacho.tipo_despacho !== "Carga" && `${user.nombre} ${user.apellido}`}
                    
                    {despacho.vehiculo && <> | <strong> VEHÍCULO:</strong>{despacho.vehiculo.ficha}</>}
                </div>

                <div className="col-12 col-md-6 d-flex justify-content-end">
                    <strong>TOTAL DE FACTURAS:</strong> <span className="ml-1 mr-4">{despacho.facturas?.length || 0}</span>
                    <strong className="mr-1">FECHA DE ENTREGA:</strong> {despacho.fecha_entrega ? dayjs(despacho.fecha_entrega).format("DD/MM/YYYY") : ""}
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <table className="table m-b-40">
                        <thead>
                            <tr>
                                <th>Orden de carga</th>
                                <th>Fecha</th>
                                <th>NCF/Numero</th>
                                <th>Cliente</th>
                                <th>Teléfono</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {despacho.facturas?.map((factura, index) => (
                                <tr key={factura.id}>
                                    <td>{index + 1}</td>
                                    <td>{dayjs(factura.fecha).format("DD/MM/YYYY")}</td>
                                    <td>{factura.numero_comprobante || factura.numero}</td>
                                    <td>{factura.cliente?.nombre}</td>
                                    <td>{factura.cliente?.telefono}</td>
                                    <td>{formatCurrency(factura.total)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5} className="text-right">
                                    <strong>TOTAL:</strong>
                                </td>
                                <td>
                                    <strong>{formatCurrency(despacho.facturas.reduce((acc, factura) => acc + factura.total, 0))}</strong>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12 col-md-4 offset-md-1">
                    <div className="text-center" style={{borderBottom: '1px solid #000'}}>{user.nombre} {user.apellido}</div>
                    <div className="text-center">ELABORADO POR</div>
                </div>

                <div className="col-12 col-md-4 offset-md-2">
                    <div className="text-center" style={{borderBottom: '1px solid #000'}}>{despacho.tipo_despacho === "Carga" && despacho.empleado ? `${despacho.empleado.nombre} ${despacho.empleado.apellido}` : "\u00a0"}</div>
                    <div className="text-center">RECIBIDO POR</div>
                </div>
            </div>
        </>}
    </>);
}

export default ReporteOrdenCarga;